"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueLinksApi = void 0;
var _constants = require("../constants");
var _endpointHelpers = require("../util/endpointHelpers");
var _queryClientUtils = require("../util/queryClientUtils");
const IssueLinksApi = exports.IssueLinksApi = (0, _endpointHelpers.createEndpointSdk)(_ref => {
  let {
    api
  } = _ref;
  return {
    create: (issueId, links) => api.create("issues/".concat(issueId, "/links"), links),
    delete: (issueId, links) => api.request("issues/".concat(issueId, "/links:delete"), _constants.HttpMethod.Post, links)
  };
}, {
  // no queries to invalidate (reference-picker uses relationships service)
  invalidateByQueryKeys: () => _queryClientUtils.NO_QUERIES_TO_INVALIDATE
});
//# sourceMappingURL=IssueLinksApi.js.map